var _path, _rect, _path2, _path3, _rect2, _rect3, _g, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalBannerMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 77,
    viewBox: "0 0 367 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6077_22496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 367,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.125 0.781372L366.125 52.462C366.125 65.583 355.488 76.2196 342.367 76.2196L24.6326 76.2196C11.5116 76.2196 0.874997 65.583 0.874998 52.462L0.875 0.781356L366.125 0.781372Z",
    fill: "url(#paint0_linear_6077_22496)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6077_22496)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139.151,
    height: 381.835,
    transform: "matrix(-8.55756e-08 1 1 4.48215e-08 0.682617 -42.0527)",
    fill: "url(#paint1_radial_6077_22496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.509 90.5915C320.396 91.3116 316.895 91.3124 314.761 90.6147L245.253 67.8952C243.118 67.1975 243.167 66.0676 245.197 65.3226C255.306 61.6126 262.176 57.0833 265.02 52.2136C268.209 46.7549 266.188 41.1296 259.228 36.0921C258.816 35.7936 258.387 35.4981 257.943 35.2057L265.934 30.6958C262.392 23.8692 255.893 19.1626 250.609 16.0153C244.723 12.5087 237.443 9.2802 229.277 6.37374C212.886 0.540376 191.271 -4.57748 166.153 -7.8804C151.282 -9.83581 135.014 -11.177 117.68 -11.6295C134.598 -13.6442 152.365 -14.9021 170.492 -15.3403C209.993 -16.2952 249.312 -13.3118 283.174 -6.79014C317.037 -0.268491 343.824 9.47956 359.944 21.1467C376.063 32.8139 380.744 45.8423 373.359 58.4847C366.318 70.539 348.628 81.6927 322.509 90.5915ZM-10.8322 43.4828C-12.697 51.5942 -9.7175 59.7725 -1.90776 67.5567C9.73284 79.1592 31.5738 89.3573 60.8916 96.916C63.2642 97.5277 66.7321 97.36 68.5767 96.5661L128.642 70.7142C130.486 69.9203 130.001 68.8033 127.702 68.163C116.251 64.9742 107.693 60.8179 102.99 56.1306C97.719 50.8765 97.5443 45.2065 102.49 39.8811C105.655 36.4721 110.822 33.3087 117.645 30.557C79.3665 28.9026 34.9187 31.9801 -10.8322 43.4828Z",
    fill: "#F8FEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.893 47.7047C172.301 47.9044 171.914 48.1705 171.857 48.4673C171.793 48.7994 172.152 49.1067 172.783 49.3345L169.988 48.5362L172.892 47.6949L172.893 47.7047Z",
    fill: "#2C94F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6077_22496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -16,
    y: -24,
    width: 399,
    height: 134
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 129.756,
    height: 397.943,
    rx: 64.878,
    transform: "matrix(0.1054 0.99443 -0.999889 0.0148777 375.611 -24.047)",
    fill: "#2AACFA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6077_22496)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 129.756,
    height: 397.943,
    rx: 64.878,
    transform: "matrix(0.1054 0.99443 -0.999889 0.0148777 375.611 -24.0472)",
    fill: "url(#paint2_linear_6077_22496)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_d_6077_22496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.689 20.3176C191.108 1.13811 150.965 -16.2075 139.124 -38.9646C816.456 -2.05455 447.49 72.7223 249.232 119.254C98.3826 154.659 36.3356 148.181 -6.64996 101.491C-39.4258 65.8908 41.7831 37.6597 112.689 20.3176Z",
    fill: "url(#paint3_linear_6077_22496)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6077_22496)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.972 18.9322C244.556 -8.89098 227.085 -30.4339 225.857 -50.3925C731.19 -48.1419 392.064 76.3175 312.43 101.43C175.475 144.62 78.2545 115.639 52.1994 102.065C31.3949 91.226 31.6824 66.5094 65.0838 48.5885C82.81 36.7001 107.953 28.5237 142.972 18.9322Z",
    fill: "url(#paint4_linear_6077_22496)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.6757 49.0008L65.6901 48.993L65.7031 48.9843C83.376 37.1316 108.457 28.9703 143.475 19.3791C194.291 5.46104 215.42 -6.90777 223.653 -18.3452C229.963 -27.1104 228.679 -35.3405 227.46 -43.1561C227.103 -45.4458 226.752 -47.6999 226.598 -49.9215C289.549 -49.6323 339.353 -47.4436 378.157 -43.7881C417.066 -40.1228 444.853 -34.9882 463.722 -28.8463C473.15 -25.7777 480.302 -22.4735 485.5 -19.0028C490.682 -15.5422 493.964 -11.8878 495.621 -8.07091C498.952 -0.395548 495.72 7.96858 487.839 16.5909C472.097 33.8116 438.09 51.7707 402.997 67.0044C367.918 82.232 331.806 94.7143 311.909 100.989C175.04 144.151 78.1217 115.116 52.4697 101.752C42.5285 96.5731 37.3981 87.948 39.0354 78.2286C40.6672 68.5415 49.0275 57.9331 65.6757 49.0008Z",
    stroke: "url(#paint5_linear_6077_22496)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6077_22496)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.83 30.7479C318.414 2.92476 382.302 -61.161 402.855 -78.8709C712.849 -65.8609 465.34 75.8637 385.707 100.977C248.751 144.166 173.644 123.579 125.476 101.611C88.9778 84.9649 123.978 56.1796 216.83 30.7479Z",
    fill: "url(#paint6_linear_6077_22496)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.333 31.1948C309.191 6.0357 370.249 -48.7367 396.332 -72.1343C399.069 -74.5891 401.42 -76.6986 403.382 -78.3923C441.983 -76.7623 471.867 -73.1335 494.461 -67.9982C517.113 -62.8496 532.315 -56.2159 541.668 -48.6393C551.013 -41.0695 554.692 -32.4172 553.931 -23.0976C553.17 -13.78 547.974 -3.86514 539.716 6.1686C523.203 26.2327 494.519 46.6891 464.974 63.7031C435.428 80.7169 405.054 94.2693 385.185 100.535C316.745 122.118 263.814 127.747 222.031 125.26C180.281 122.776 149.628 112.188 125.678 101.265C121.231 99.2368 117.928 97.0498 115.685 94.7353C113.442 92.4203 112.214 89.9309 112.018 87.2818C111.627 81.9632 115.405 76.0704 123.284 69.8568C139.026 57.4421 170.927 43.9054 217.333 31.1948Z",
    stroke: "url(#paint7_linear_6077_22496)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.825 47.6107C338.375 25.5484 365.036 3.4062 384.535 -12.7879C389.607 -17.0004 394.194 -20.8104 399.12 -24.1119C427.448 -23.1398 449.993 -20.6681 467.601 -17.0519C485.261 -13.4248 497.865 -8.66478 506.364 -3.16867C514.831 2.30727 519.351 8.59843 520.676 15.4247C522.004 22.2633 520.115 29.6056 515.793 37.1083C507.151 52.1104 488.842 67.6474 467.551 80.9517C446.262 94.2541 422.023 105.303 401.557 111.343C337.115 130.36 288.561 136.545 247.975 134.605C207.428 132.666 174.787 122.615 142.099 109.069C137.612 107.209 134.719 105.308 133.137 103.377C131.552 101.441 131.194 99.3646 132.091 97.1347C133.891 92.6582 140.667 87.774 151.584 82.5346C173.386 72.0712 211.396 60.3273 257.825 47.6107Z",
    fill: "url(#paint8_linear_6077_22496)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.825 47.6107C338.375 25.5484 365.036 3.4062 384.535 -12.7879C389.607 -17.0004 394.194 -20.8104 399.12 -24.1119C427.448 -23.1398 449.993 -20.6681 467.601 -17.0519C485.261 -13.4248 497.865 -8.66478 506.364 -3.16867C514.831 2.30727 519.351 8.59843 520.676 15.4247C522.004 22.2633 520.115 29.6056 515.793 37.1083C507.151 52.1104 488.842 67.6474 467.551 80.9517C446.262 94.2541 422.023 105.303 401.557 111.343C337.115 130.36 288.561 136.545 247.975 134.605C207.428 132.666 174.787 122.615 142.099 109.069C137.612 107.209 134.719 105.308 133.137 103.377C131.552 101.441 131.194 99.3646 132.091 97.1347C133.891 92.6582 140.667 87.774 151.584 82.5346C173.386 72.0712 211.396 60.3273 257.825 47.6107Z",
    stroke: "url(#paint9_linear_6077_22496)",
    strokeWidth: 1.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6077_22496)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.258 63.4484C366.333 43.9477 440.303 7.04673 464.278 -8.96614C537.524 9.57247 529.286 91.9999 442.221 114.084C355.157 136.168 242.242 127.492 181.928 108.446C165.34 101.572 158.183 82.9492 262.258 63.4484Z",
    fill: "url(#paint10_linear_6077_22496)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.716 63.9056C366.578 44.4448 440.479 7.66939 464.698 -8.43776C482.519 -3.85534 495.362 4.5625 503.346 15.003C511.415 25.5535 514.531 38.1899 512.644 50.9876C508.871 76.5771 485.122 102.628 441.728 113.635C398.263 124.66 348.34 128.007 301.758 126.221C255.192 124.435 212.027 117.521 182.024 108.056C178.091 106.417 174.815 104.13 173.539 101.334C172.24 98.4901 172.953 95.0027 177.492 91.0569C186.565 83.1678 210.69 73.6539 262.716 63.9056Z",
    stroke: "url(#paint11_linear_6077_22496)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6077_22496",
    x: -60.2522,
    y: -82.1952,
    width: 635.635,
    height: 273.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.0563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.02125 0 0 0 0 0.0616251 0 0 0 0 0.425 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6077_22496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6077_22496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6077_22496",
    x: 15.6759,
    y: -69.8463,
    width: 504.305,
    height: 219.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1679
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0425347 0 0 0 0 0.0525 0 0 0 0 0.291667 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6077_22496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6077_22496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6077_22496",
    x: 73.8001,
    y: -113.455,
    width: 518.418,
    height: 280.079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7332
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00616318 0 0 0 0 0.122031 0 0 0 0 0.295833 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6077_22496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6077_22496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6077_22496",
    x: 142.695,
    y: -35.625,
    width: 400.748,
    height: 195.191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7704
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.333333 0 0 0 0 0.890196 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6077_22496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6077_22496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6077_22496",
    x1: 385.019,
    y1: 2.39791,
    x2: 334.102,
    y2: 123.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#319FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555FD2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6077_22496",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-32.3957 -129.261) rotate(74.2259) scale(607.645 362.813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177023,
    stopColor: "#2AACFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431754,
    stopColor: "#205BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629073,
    stopColor: "#1C46AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#172A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6077_22496",
    x1: 62.222,
    y1: 148.113,
    x2: -174.139,
    y2: 259.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5361E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20088,
    stopColor: "#5F5BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F2885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6077_22496",
    x1: 319.138,
    y1: 48.788,
    x2: -70.5435,
    y2: -211.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#486AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8046D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6077_22496",
    x1: 344.269,
    y1: -1.55404,
    x2: -252.145,
    y2: -62.6873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E72E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754DDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6077_22496",
    x1: 221.84,
    y1: -15.9116,
    x2: 181.169,
    y2: 123.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6077_22496",
    x1: 338.154,
    y1: 10.5969,
    x2: 232.215,
    y2: 248.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D6CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6077_22496",
    x1: 331.464,
    y1: -4.08217,
    x2: 275.293,
    y2: 144.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6077_22496",
    x1: 340.404,
    y1: 43.7098,
    x2: 265.943,
    y2: 251.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2094EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6077_22496",
    x1: 302.983,
    y1: 43.6277,
    x2: 241.598,
    y2: 151.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6077_22496",
    x1: 429.899,
    y1: 61.7471,
    x2: 220.632,
    y2: 202.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3994EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6077_22496",
    x1: 319.171,
    y1: 53.5712,
    x2: 271.434,
    y2: 131.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBannerMobile);
export default __webpack_public_path__ + "static/media/modal-banner-mobile.b84b6e302e7edeb44e05108ccf3cfc94.svg";
export { ForwardRef as ReactComponent };